<template>
  <v-card :class="'cardTab'">
    <div class="center">
      <h4><fs1-span>No se encontro la pagina buscada...</fs1-span></h4>
    </div>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      
    };
  }
};
</script>

<style scoped>
  .center {
    margin: auto;
    width: 50%;
    padding: 10px;
  }
</style>
